import React from "react";
import { Label } from "semantic-ui-react";

const BorderlessLabel = ({ children, style, ...rest }) => (
  <Label color="orange" basic style={{ border: "none", padding: 0, ...style }} {...rest}>
    {children}
  </Label>
);

export default BorderlessLabel;
